import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import SideMenu from './NavMenuJson.json';
import './SideMenuBar.scss';
import { getBusinessSetting } from '../../actions/BusinessUserActions';

class SideMenuBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      sidemenu: []
    };
    props.dispatch(getBusinessSetting(props.businessInfo.businessId, this.getBusinessDetails));
  }

  getBusinessDetails = (data) => {
    this.setState({ sidemenu: data.sidemenu || this.state.sidemenu });
  }

  onSelect = () => this.setState({ expanded: false });
  onToggle = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }));
    this.props.ontoogleMenu(!this.state.expanded)
    // setTimeout(() => {
    //   this.setState({ expanded: false });
    //   this.props.ontoogleMenu(false)
    // }, 10000);
  }


  getImage = () => {
    if (this.props.businessInfo && this.props.businessInfo.businessLogo) {
      return <img src={this.props.businessInfo.businessLogo} width={100} style={{ padding: '5px', width: 200, height: 50 }} />
    } else {
      return <div className="logo-magic-orbits" style={{ paddingLeft: 10 }}><img src='../../../assets/images/logo.png' width={135} /></div>
    }
  }

  loadTranslations = (value, currentLanguage) => {
    const currentLang = currentLanguage ? currentLanguage : 'en';
    return this.props.translations ? this.props.translations[value] ? this.props.translations[value][currentLang] ? this.props.translations[value][currentLang] : value : value : value;
  }

  render() {
    let menu = this.props.userInfo ?
      this.props.userInfo.type === 'cogitatioAdmin' && SideMenu.cogitatioAdmin ||
      this.props.userInfo.type === 'admin' && SideMenu.admin ||
      this.props.userInfo.type === 'user' && SideMenu.user ||
      [] : [];
    if (this.props.userInfo.type === 'user') {
      const filteredMenu = menu.filter((val) => {
        const findMenu = this.state.sidemenu.find(dat => dat.name === val.name);
        return findMenu && findMenu.active
      });
      menu = filteredMenu;
    }
    const { expanded } = this.state;
    return (
      <SideNav
        expanded={expanded}
        onSelect={this.onSelect}
        onToggle={this.onToggle}
      >
        <SideNav.Toggle />
        {this.state.expanded && this.getImage()
        }
        <SideNav.Nav defaultSelected="home">
          {menu
            ? menu.map(data => (
              <NavItem eventKey={data.name}>
                <NavIcon>
                  <Link to={data.route}>
                    {data.iconFlag ?
                      <i title={this.loadTranslations(data.name, this.props.currentLanguage)} className={data.icon} style={{ color: '#ffffff' }}></i>
                      : <img src={data.icon} alt="" />}
                  </Link>
                </NavIcon>
                <NavText style={{ color: '#fff'}}>
                  {!data.childrens ?
                    <Link to={data.route} className="margin-left10">
                      {this.loadTranslations(data.name, this.props.currentLanguage)}
                    </Link> :
                    this.loadTranslations(data.name, this.props.currentLanguage)}
                </NavText>
                {data.childrens && data.childrens.map(child => (
                  <NavItem eventKey={child.name}>
                    <NavIcon style={{ display: 'inline-block', width: 25 }}>
                      <Link to={child.route}>
                        {child.iconFlag ?
                          <i title={this.loadTranslations(child.name, this.props.currentLanguage)} className={child.icon} style={{ color: '#ffffff' }}></i>
                          : <img src={child.icon} alt="" />}
                      </Link>
                    </NavIcon>
                    <NavText style={{ display: 'inline-block' }}>
                      <Link to={child.route} className="margin-left10">
                        {this.loadTranslations(child.name, this.props.currentLanguage)}
                      </Link>
                    </NavText>
                  </NavItem>
                ))}
              </NavItem>
            ))
            : null}
          {/* end */}
        </SideNav.Nav>
      </SideNav>
    );
  }
}
function mapStateToProps(state) {
  return {
    userInfo: state.users.userInfo,
    businessInfo: state.users.businessInfo,
    currentLanguage: state.users.currentLanguage,
    translations: state.users.translations

  };
}
export default connect(mapStateToProps)(SideMenuBar);



// WEBPACK FOOTER //
// ./screens/SideMenuBar/SideMenuBar.js